import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { SnackbarWrapper } from "context/SnackbarContext";
import { ConfirmContextWrapper } from "context/ConfirmDialogContext";
const Contextswrapper = ({ children }) => {
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <ConfirmContextWrapper>
          <SnackbarWrapper>{children}</SnackbarWrapper>
        </ConfirmContextWrapper>
      </LocalizationProvider>
    </>
  );
};

export default Contextswrapper;
